import React, { useState, useEffect } from "react";

import { Container, Box } from "@mui/material";

export default function Hero({
  backgroundImage,
  fallbackImage,
  backgroundTint,
  children,
  maxWidth,
  sxBackground,
  sxBox
}) {
  const [currentBackgroundImage, setCurrentBackgroundImage] =
    useState(backgroundImage);

  useEffect(() => {
    if (backgroundImage) {
      // Test if the primary background image loads
      const img = new Image();
      img.onload = () => {
        setCurrentBackgroundImage(backgroundImage);
      };
      img.onerror = () => {
        if (fallbackImage) {
          setCurrentBackgroundImage(fallbackImage);
        }
      };
      img.src = backgroundImage;
    }
  }, [backgroundImage, fallbackImage]);

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        background: `${
          backgroundTint
            ? typeof backgroundTint === "string" && backgroundTint !== ""
              ? backgroundTint.trim() + ", "
              : `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.6)), `
            : ""
        }url('${currentBackgroundImage}') center center/cover no-repeat`,
        color: "text.primary",
        minHeight: "70vh",
        width: "100%",
        objectFit: "contain",
        ...sxBackground
      }}
    >
      <Box
        sx={{
          pt: 8,
          pb: 6,
          height: "100%",
          width: "100%",
          textAlign: "center",
          display: "flex",
          flexFirection: "column",
          justifyContent: "center",
          alignItems: "center",
          ...sxBox
        }}
      >
        <Container maxWidth={maxWidth || "sm"} sx={{ p: 1 }}>
          {children}
        </Container>
      </Box>
    </Box>
  );
}
